var portfolioPositionsPerformance = {
	caption: "Evolución de las posiciones del portafolio",
	label: {
		name: "Nombre",
		isin: "ISIN",
		performance: "Rendimiento",
		performanceRelative: "Rendimiento %",
		performanceBar: "Rendimiento % of max"
	},
	noPositions: "Sin Resultados"
};
var es = {
	portfolioPositionsPerformance: portfolioPositionsPerformance
};

export { es as default, portfolioPositionsPerformance };
